import React from "react";

const ASP_e_mail = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP e mail</h1>
      <p>This is the ASP e mail page content.</p>
    </div>
  );
};

export default ASP_e_mail;
